<template>
  <div class="treeWarper">
    <div class="filterGroups">
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        clearable
        size="mini"
      >
      </el-input>
    </div>
    <div class="groupTree" ref="groupTree" :style='{ height: maxGroupHeight + "px" }'>
      <el-tree class="treeWarpers" :data="treeList" :props="defaultProps" show-checkbox @check="clickTree" node-key="id"
        ref="trees" :filter-node-method="filterNode" :indent="8">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <el-popover placement="top-start" width="250" trigger="click">
            <i class="el-icon-key" style="padding: 0 2px; cursor: pointer; color: gray" slot="reference"></i>
            <div class="content">
              <div>账号: {{ data.name }} </div>
              <div>密码: {{ data.user ? data.user.username.slice(-6) : '' }}</div>
              <div>网址: {{ loginUrl }}</div>
            </div>
          </el-popover>

          <span class="comment">{{ data.comment }}</span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { getGroupTree } from "@/api/project";
export default {
  data() {
    return {
      treeList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      maxGroupHeight: "",
      loginUrl: window.location.protocol +"//"+ window.location.hostname + (window.location.port != 80 ? (':'+window.location.port) : '') + "/admin/street/login?project_id=" + this.$route.params.id
    };
  },
  mounted() {
    this.getList();
    this.maxGroupHeight = this.$refs.groupTree.clientHeight;
  },
  watch: {
    filterText(val) {
      this.$refs.trees.filter(val);
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getList() {
      let project_id = this.$route.params.id;
      getGroupTree({ project_id }).then((res) => {
        this.treeList = res.data;
      });
    },
    clickTree(data) {
      this.$emit("clickTree", this.$refs.trees.getCheckedKeys());
    },
    handleNodeClick(data) {
      console.log(data);
    },
  },
};
</script>

<style scoped>
.groups-tree {
  overflow-y: scroll;
  height: calc(100vh - 98px);
}

.treeWarper {
  /* background: #efefef; */
  position: relative;
  height: 100%;
}

.treeWarpers {
  /* background: #efefef; */
  position: relative;
  height: 100%;
  overflow: auto;
}

.filterGroups {
  position: absolute;
  left: 50%;
  width: 80%;
  transform: translate(-50%);
  top: 0;
}

.treeWarper {
  padding-top: 40px;
}

.groupTree {
  overflow-y: auto;
  height: calc(100%);
}

.custom-tree-node .comment {
  color: lightgrey;
  font-size: 12px;
}
</style> 